const INIT_DATA_HASH_PREFIX = '#exodeInitData=';

let cachedInitData: string | null = null;

/**
 * Read `#exodeInitData=<urlencoded>` from location.hash.
 *
 * The fragment is removed after the first read (like Telegram's `#tgWebAppData`)
 * so the signed payload does not leak via copied links, and the value is cached
 * for subsequent calls. Send the returned string to your backend and verify it
 * there with `verifyInitData` from `@exode-team/sdk/miniapp/server`.
 */
export function retrieveInitData(): string | null {
    if (cachedInitData !== null) {
        return cachedInitData;
    }

    if (typeof window === 'undefined') {
        return null;
    }

    const { hash } = window.location;

    if (!hash.startsWith(INIT_DATA_HASH_PREFIX)) {
        return null;
    }

    cachedInitData = decodeURIComponent(hash.slice(INIT_DATA_HASH_PREFIX.length));

    window.history.replaceState(
        null,
        '',
        window.location.pathname + window.location.search,
    );

    return cachedInitData;
}
